module.exports = __webpack_public_path__ + "static/media/logo.f641c6b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/logo.svg
// module id = 387
// module chunks = 7